import { render, staticRenderFns } from "./RequisicionComponent.vue?vue&type=template&id=fde4830c&scoped=true&"
import script from "./RequisicionComponent.vue?vue&type=script&lang=js&"
export * from "./RequisicionComponent.vue?vue&type=script&lang=js&"
import style0 from "./RequisicionComponent.vue?vue&type=style&index=0&id=fde4830c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde4830c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
